export const DEFAULT_IDLE_AWAY_TIMEOUT_IN_MINUTES = 600;
